export const projectCards = {
    projectCard: {
        entity: 'project',
        path: 'project',
        titleBar: { mergeParams: ['name'], new: 'project.form.new.title' },
        cardTitle: {
            title: 'project.form.dropdown.toggle',
            buttons: [
                {
                    type: 'submit',
                    id: 'projectCard.save',
                    action: 'save',
                    label: 'all.form.button.save',
                    icon: 'save',
                    variant: 'primary',
                    confirm: false
                }
            ],
            menuItems: [
                {
                    action: 'createInvoice',
                    label: 'project.menu.createInvoice',
                    confirm: true,
                    modalConfig: 'projectConfirmCreateInvoice'
                },
                {
                    action: 'archive',
                    label: 'all.menu.item.archive',
                    confirm: false,
                    dependency: { id: 'archived', value: false }
                },
                {
                    action: 'unarchive',
                    label: 'all.menu.item.unarchive',
                    confirm: false,
                    dependency: { id: 'archived', value: true }
                },
                {
                    action: 'delete',
                    label: 'project.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'projectConfirmDelete'
                }
            ],
            actions: {
                archive: { message: 'project.action.archive.message' },
                unarchive: { message: 'project.action.unarchive.message' }
            }
        },
        sections: [{
            id: 'project',
            meta: { type: 'form', width: '800px' },
            groups: [
                {
                    type: 'text',
                    id: 'name',
                    label: 'project.form.name',
                    placeholder: 'project.form.name.placeholder',
                    required: true
                },
                {
                    type: 'textarea',
                    id: 'description',
                    label: 'project.form.description',
                    placeholder: 'project.form.description.placeholder',
                    rows: 3
                },
                {
                    type: 'select',
                    id: 'status',
                    displayField: 'statusName',
                    label: 'project.form.status',
                    entity: 'projectStatus',
                    valueMap: { 'status': 'id', 'statusName': 'name' },
                    options: { withHeaders: false },
                    required: true,
                },
                {
                    type: 'dualconnect',
                    id: 'contactId',
                    displayField: 'contactName',
                    label: 'project.form.customerName',
                    placeholder: 'project.form.customerName.placeholder',
                    modalTitle: 'project.form.customer.modal.title',
                    entity: 'contact',
                    entityParams: { type: 'filter', filters: [{ key: 'contactType', value: 'customer|both|undefined' }] },
                    valueMap: {
                        'companyTypeId': 'companyTypeId',
                        'contactName': 'name',
                        'contactId': 'id',
                        'contactAddress_street': 'address_street',
                        'contactAddress_city': 'address_city',
                        'contactAddress_postCode': 'address_postCode',
                        'contactAddress_region': 'address_region',
                        'contactCountry': 'country',
                        'contactCountryName': 'countryName',
                        'contactEmail': 'email'
                    },
                    options: { withHeaders: false },
                    required: true,
                    sub: {
                        id: 'contactPersonId',
                        displayField: 'contactPersonName',
                        placeholder: 'project.form.contactPerson.name.placeholder',
                        modalTitle: 'project.form.contactPerson.modal.title',
                        entity: 'contactPerson',
                        valueMap: {
                            'contactPersonName': 'name',
                            'contactPersonId': 'id',
                            'contactEmail': 'email'
                        }
                    }
                },
                {
                    type: 'number',
                    id: 'projectRate',
                    label: 'project.form.rate',
                    placeholder: 'project.form.rate.placeholder',
                    required: true,
                    decimals: 5,
                    defaultType: 'value',
                    defaultValue: 1,
                    variant: 'price'
                },
            ],
            buttons: [
                {
                    type: 'button',
                    id: 'projectCard.project.close',
                    action: 'close',
                    label: 'all.form.button.save',
                    variant: 'primary'
                }
            ],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1,
                    basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'description', scale: 'normal' },
                        { type: 'field', value: 'status', scale: 'normal' }
                    ]
                }]
            }
        }]
    },

    projectSettingsCard: {
        entity: 'projectSettings',
        path: 'projectSettings',
        titleBar: { label: 'project.settings.heading', mergeParams: ['settingsType'], new: 'project.settings.title' },
        width: '756px',
        afterSubmit: { stay: true },
        sections: [
            {
                id: 'projectSettings.defaults',
                meta: {
                    type: 'form',
                    width: '756px'
                },
                groups: [
                    {
                        type: 'description',
                        id: 'defaults',
                        label: 'project.settings.defaults.title',
                        text: 'project.settings.defaults.description'
                    },
                    {
                        type: 'separator',
                        id: 'separator'
                    },
                    {
                        type: 'connect',
                        id: 'defaultProductId',
                        displayField: 'defaultProductName',
                        label: 'project.settings.defaultProduct',
                        placeholder: 'project.settings.defaultProduct.placeholder',
                        modalTitle: 'project.settings.defaultProduct.modal.title',
                        entity: 'product',
                        valueMap: {
                            'defaultProductId': 'id',
                            'defaultProductName': 'name',
                            'defaultProductNetPrice': 'netSalesPrice',
                            'defaultProductTaxId': 'taxId',
                            'defaultProductTaxName': 'taxName',
                            'defaultProductTaxRate': 'taxRate'
                        }
                    }
                ],
                buttons: [
                    { type: 'submit', id: 'projectSettingsCard.defaults.save', action: 'save', label: 'all.form.button.update', icon: 'save', variant: 'primary' }
                ],
                displaySection: {
                    emptyField: 'settingtype',
                    emptyMessage: 'project.settings.display.title',
                    columns: [
                        {
                            weight: 1, basis: '100%',
                            elements: [
                                { type: 'text', value: 'project.settings.display.title', scale: 'title' }
                            ]
                        }
                    ]
                }
            }
        ]
    },

    projectTaskCard: {
        entity: 'projectTask',
        path: 'project/:id/projectTask',
        titleBar: { mergeParams: ['title'], new: 'project.task.form.new.title' },
        cardTitle: {
            title: 'project.task.form.dropdown.toggle',
            buttons: [{
                type: 'submit',
                id: 'projectTaskCard.save',
                action: 'save',
                label: 'all.form.button.save',
                icon: 'save',
                variant: 'primary',
                condition: { field: '$mode', operator: 'equals', value: 'edit' }
            }],
            menuItems: [
                {
                    action: 'delete',
                    label: 'project.task.form.dropdown.delete',
                    confirm: true,
                    modalConfig: 'projectTaskConfirmDelete'
                }
            ]
        },
        width: '600px',
        sections: [
            // Section 1 - Task Information
            {
                id: 'projectTask.info',
                meta: { type: 'form', onMount: { new: 'expand', edit: 'collapse' }, width: '600px' },
                groups: [
                    {
                        type: 'text',
                        id: 'title',
                        label: 'project.task.form.title',
                        placeholder: 'project.task.form.title.placeholder',
                        required: true
                    },
                    {
                        type: 'textarea',
                        id: 'description',
                        label: 'project.task.form.description',
                        placeholder: 'project.task.form.description.placeholder',
                        rows: 2
                    },
                    {
                        type: 'group',
                        id: 'dueDateProjectName',
                        fields: [
                            {
                                type: 'date',
                                id: 'dueDate',
                                label: 'project.task.form.dueDate',
                                defaultType: 'date'
                            },
                            {
                                type: 'text-readOnly',
                                id: 'projectName',
                                label: 'project.task.form.projectName'
                            }
                        ]
                    }
                ],
                buttons: [{
                    type: 'button',
                    id: 'projectTaskCard.info.close',
                    action: 'close',
                    label: 'all.form.button.update',
                    icon: 'save',
                    variant: 'primary'
                }],
                displaySection: {
                    emptyField: 'title',
                    columns: [{
                        weight: 1,
                        basis: '100%',
                        elements: [
                            { type: 'field', value: 'title', scale: 'title' },
                            { type: 'field', value: 'description', scale: 'normal' },
                            { type: 'date', value: 'dueDate', scale: 'normal' }
                        ]
                    }]
                }
            },
            // Section 2 - Task Effort
            {
                id: 'projectTask.effort',
                meta: { type: 'form', width: '600px' },
                groups: [
                    {
                        type: 'description',
                        id: 'effort',
                        label: 'project.task.form.effort.title',
                        text: 'project.task.form.effort.text'
                    },
                    {
                        type: 'group',
                        id: 'effortQuantityUnitId',
                        label: 'project.task.form.effort',
                        focus: false,
                        mobileRow: true,
                        fields: [
                            {
                                type: 'number',
                                id: 'effortQuantity',
                                placeholder: 'invoice.form.itemQuantity',
                                required: true,
                                decimals: 5,
                                defaultType: 'value',
                                defaultValue: 1,
                                variant: 'quantity'
                            },
                            {
                                type: 'select',
                                id: 'effortUnitId',
                                displayField: 'effortUnitName',
                                placeholder: 'invoice.form.unitName.placeholder',
                                entity: 'unit',
                                valueMap: {
                                    'effortUnitName': 'name',
                                    'effortUnitId': 'id'
                                },
                                options: { withHeaders: true },
                                required: true,
                                defaultValue: 'HOUR'
                            }
                        ]
                    },
                    {
                        type: 'group',
                        id: 'statusPriority',
                        mobileRow: true,
                        fields: [
                            {
                                type: 'select',
                                id: 'status',
                                displayField: 'statusName',
                                label: 'project.task.form.status',
                                placeholder: 'taskStatus.placeholder',
                                entity: 'taskStatus',
                                valueMap: { 'status': 'id', 'statusName': 'name' },
                                options: { withHeaders: false },
                                required: true,
                            },
                            {
                                type: 'select',
                                id: 'priority',
                                displayField: 'priorityName',
                                label: 'project.task.form.priority',
                                placeholder: 'taskPriority.placeholder',
                                entity: 'taskPriority',
                                valueMap: { 'priority': 'id', 'priorityName': 'name' },
                                options: { withHeaders: false },
                                required: true,
                            }
                        ]
                    },
                    {
                        type: 'connect',
                        id: 'assigneeId',
                        displayField: 'assigneeName',
                        label: 'project.task.form.assigneeName',
                        placeholder: 'project.task.form.assigneeName.placeholder',
                        entity: 'employee',
                        valueMap: { 'assigneeId': 'id', 'assigneeName': 'name' },
                        options: { withHeaders: false },
                        filter: { app: 'project' }
                    }
                ],
                buttons: [{
                    type: 'button',
                    id: 'projectTaskCard.effort.close',
                    action: 'close',
                    label: 'all.form.button.update',
                    icon: 'save',
                    variant: 'primary'
                }],
                displaySection: {
                    emptyField: 'status',
                    columns: [
                        {
                            weight: 1,
                            basis: '60%',
                            elements: [
                                { type: 'merge', value: '${1} · ${2}', mergeParams: ['statusName', 'priorityName'], scale: 'title' },
                                { type: 'field', value: 'assigneeName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '40%',
                            align: 'end',
                            elements: [
                                { type: 'merge', value: '${1} ${2}', mergeParams: ['effortQuantity', 'effortUnitName'], scale: 'normal' }
                            ]
                        }
                    ]
                }
            },
            // Section 3 - Task Billing
            {
                id: 'projectTask.billing',
                meta: { type: 'form', onMount: 'collapse', width: '600px' },
                groups: [
                    {
                        type: 'connect',
                        id: 'itemId',
                        displayField: 'itemName',
                        label: 'project.task.form.item',
                        placeholder: 'project.task.form.item.placeholder',
                        entity: 'product',
                        valueMap: {
                            'itemId': 'id',
                            'itemName': 'name',
                            'itemNetPrice': 'netSalesPrice',
                            'itemTaxId': 'taxId',
                            'itemTaxName': 'taxName',
                            'itemTaxRate': 'taxRate'
                        },
                        nullDefaults: { itemTaxRate: 0 },
                        options: { withHeaders: false },
                    },
                    {
                        type: 'switch',
                        id: 'invoiced',
                        label: 'project.task.form.invoiced',
                        switchText: 'project.task.form.invoiced.switchText'
                    }
                ],
                buttons: [{
                    type: 'button',
                    id: 'projectTaskCard.billing.close',
                    action: 'close',
                    label: 'all.form.button.update',
                    icon: 'save',
                    variant: 'primary'
                }],
                displaySection: {
                    emptyField: 'itemName',
                    columns: [
                        {
                            weight: 1,
                            basis: '60%',
                            elements: [
                                { type: 'text', value: 'project.task.form.billing.label', scale: 'title' },
                                { type: 'field', value: 'itemName', scale: 'normal' }
                            ]
                        },
                        {
                            weight: 1,
                            basis: '40%',
                            elements: [
                                { type: 'spacer', value: 'spacer', scale: 'title' },
                                {
                                    type: 'merge',
                                    value: '${1} ${2}',
                                    mergeParams: [
                                        { type: 'label', value: 'project.task.form.billing.invoiced' },
                                        { type: 'boolean', value: 'invoiced', values: ['project.task.form.billing.invoiced.true', 'project.task.form.billing.invoiced.false'] }
                                    ],
                                    scale: 'normal'
                                },
                            ]
                        }
                    ]
                }
            }]
    },

    projectTeamCard: {
        entity: 'employee',
        path: 'employee',
        titleBar: { mergeParams: ['name'] },
        cardTitle: {
            title: 'employee.form.dropdown.toggle',
            width: '600px',
            buttons: []
        },
        sections: [{
            id: 'projectTeam',
            meta: { type: 'form', width: '480px' },
            groups: [
                { type: 'text-readOnly', id: 'name', label: 'employee.list.table.displayName' },
                { type: 'text-readOnly', id: 'title', label: 'employee.list.table.title' },
                { type: 'text-readOnly', id: 'department', label: 'employee.list.table.department' }
            ],
            buttons: [],
            displaySection: {
                emptyField: 'name',
                columns: [{
                    weight: 1, basis: '100%',
                    elements: [
                        { type: 'field', value: 'name', scale: 'title' },
                        { type: 'field', value: 'title', scale: 'normal' },
                        { type: 'field', value: 'department', scale: 'normal' }
                    ]
                }]
            }
        }]
    },
}
